angular.module('aprima-legacy-common').config(['$provide', function($provide) {
    'use strict';
    $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function($delegate, $injector) {
        var AprimaAnalytics;

        return function customExceptionHandler(exception, cause) {
            var message = exception.message + ' (caused by "' + cause + '")';
            try {
                AprimaAnalytics = AprimaAnalytics || $injector.get('AprimaAnalytics');
                AprimaAnalytics.sendException(message);
            }
            catch(ex) { }
            $delegate(exception, cause);
        };
    }]);
}]);
